import React, { useState, useEffect, useRef, useMemo } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "./PowerBI.css";
import Breadcrumb from "./Breadcrumb";

const PowerBIReport = ({ accessToken, embedUrl, embedReportId }) => {
	const reportRef = useRef(null);

	const [fullScreen, setFullScreen] = useState(false);

	const handleFullScreen = () => {
		if (reportRef.current) {
			if (fullScreen) {
				document.exitFullscreen();
				setFullScreen(false);
			} else {
				reportRef.current.fullscreen();
				setFullScreen(true);
			}
		}
	};

	const style = useMemo(() => {
		return fullScreen ? "Embed-container-fullscreen" : "Embed-container";
	}, [fullScreen]);

	useEffect(() => {
		const handleFullscreenChange = () => {
			if (document.fullscreenElement) {
				setFullScreen(true);
			} else {
				setFullScreen(false);
			}
		};

		document.addEventListener("fullscreenchange", handleFullscreenChange);

		return () => {
			document.removeEventListener(
				"fullscreenchange",
				handleFullscreenChange,
			);
		};
	}, []);

	return (
		<>
			<Breadcrumb
				title="Power BI"
				backLink="/relatorios-power-bi"
				extraButton={{
					label: "Modo tela cheia",
					icon: "bx bx-fullscreen",
					onClick: handleFullScreen,
				}}
			/>
			<div className="container-fluid">
				<PowerBIEmbed
					embedConfig={{
						type: "report",
						id: embedReportId,
						embedUrl: embedUrl,
						accessToken: accessToken,
						tokenType: models.TokenType.Embed,
						settings: {
							panes: {
								pageNavigation: {
									position: models.PageNavigationPosition.Bottom,
								},
							},
							background: models.BackgroundType.Default,
							layoutType: models.LayoutType.Custom,
							customLayout: {
								displayOption: models.DisplayOption.FitToWidth
							},
						},
					}}
					eventHandlers={
						new Map([
							["loaded", () => console.log("Report loaded")],
							["rendered", () => console.log("Report rendered")],
							["error", (event) => console.error(event.detail)],
						])
					}
					cssClassName={style}
					getEmbeddedComponent={(embeddedReport) => {
						console.log("Report instance:", embeddedReport);
						reportRef.current = embeddedReport;
						window.report = embeddedReport;
					}}
				/>
			</div>
		</>
	);
};

export default PowerBIReport;
